<template>
  <div id="app">
    <nav id="nav">
      <div class="container fluid">
        <div class="row align-middle">
          <div class="col-md-2">
            <!-- title <h1>Administration</h1> -->
          </div>
          <div class="col-md-8 text-center">
            <router-link v-if="authenticated" to="/market" v-on:click.native="switchPage('MarketForm')" replace>Market Data</router-link>
            <router-link v-if="authenticated" to="/sog" v-on:click.native="switchPage('SogForm')" replace>SoG Data</router-link>
          </div>
          <div class="col-md-2 text-right">
            <router-link v-if="authenticated" to="/login" v-on:click.native="logout()" replace>Logout</router-link>
          </div>
        </div>
      </div>
    </nav>
    <router-view @authenticated="setAuthenticated" />
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      authenticated: false,
      mockAccount: {
        username: 'dummy',
        password: 'FbTAAVB-9426'
      }
    }
  },
  mounted () {
    if (!this.authenticated) {
      this.$router.replace({ name: 'login' })
    }
  },
  methods: {
    setAuthenticated (status) {
      this.authenticated = status
    },
    logout () {
      this.authenticated = false
    },
    switchPage (page) {
      this.$router.replace({ name: page })
    }
  }
}
</script>

<style>
  #app {
  }
</style>



// WEBPACK FOOTER //
// src/App.vue